import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import type { AddTaskSubTasksArgs, AddTaskSubTasksResult } from '@ztechapps/common.contract'
import { taskDocumentFragment } from './graphql'

export const addTaskSubTasksQuery = gql`
  mutation addTaskSubTasks($input: AddTaskSubTasksArgs!) {
    addTaskSubTasks(input: $input) {
      task {
        ...taskDocumentFragment
      }
      subTasks {
        ...taskDocumentFragment
      }
    }
  }
  ${taskDocumentFragment}
`

export const useAddTaskSubTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<AddTaskSubTasksResult, AddTaskSubTasksArgs> => {
  query = query ?? addTaskSubTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
